<app-modal-window title="Payback"
                  [actions]="true"
                  (close)="close()"
                  [disabledConfirm]="paybackForm.invalid || isSubmitting"
                  (confirm)="onSubmit()">
  <div class='payback-content'>
    <p *ngIf="payback">Текущий отыгрыш: {{ (payback.payback / 100) | number : '1.2-5' }}</p>
    <p>Сумма в тех же единицах, что и в таблице. Плюс — добавить, минус — списать.</p>

    <form [formGroup]="paybackForm" class="payback-form">

      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Payback type</mat-label>
        <mat-select formControlName="type">
          <mat-option *ngFor="let item of Object.values(PaybackTypeEnum)" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Action type</mat-label>
        <mat-select formControlName="actionType">
          <mat-option *ngFor="let item of Object.values(PaybackActionTypeEnum)" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Lock type</mat-label>
        <mat-select formControlName="lockType">
          <mat-option [value]="null">— не указан —</mat-option>
          <mat-option *ngFor="let item of Object.values(PaybackLockTypeEnum)" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Изменение отыгрыша</mat-label>
        <input matInput type="number" step="0.00001" formControlName="payback" placeholder="0">
      </mat-form-field>
    </form>

  </div>
</app-modal-window>
